"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Evergent_1 = require("../../core/Evergent");
var core_1 = require("../../core");
var RedfastActions = /** @class */ (function () {
    function RedfastActions(_a) {
        var apiKey = _a.apiKey, apiUrl = _a.apiUrl;
        this.ev = new Evergent_1.Evergent({ baseURL: apiUrl, apiKey: apiKey });
    }
    RedfastActions.prototype.applyCoupon = function (couponCode) {
        return this.ev.applyCoupon(couponCode).catch(core_1.logError);
    };
    RedfastActions.prototype.upgradeSubscription = function (_a) {
        var _this = this;
        var planId = _a.planId, _b = _a.couponCode, couponCode = _b === void 0 ? "" : _b, _c = _a.promotionId, promotionId = _c === void 0 ? "" : _c;
        return this.ev
            .getPaymentMethods()
            .then(function (_a) {
            var hasPaymentMethods = _a.hasPaymentMethods, methods = _a.methods;
            if (hasPaymentMethods) {
                var method = methods[0];
                var paymentmethodInfo = method.paymentmethodInfo;
                var params = {
                    planId: planId,
                    promotionId: promotionId,
                    couponCode: couponCode,
                    paymentmethodInfo: paymentmethodInfo,
                };
                return _this.ev.changeService(params);
            }
            return Promise.reject(Error("No Payment Methods found on profile"));
        })
            .catch(core_1.logError);
    };
    return RedfastActions;
}());
exports.RedfastActions = RedfastActions;
//# sourceMappingURL=Actions.js.map